import { render, staticRenderFns } from "./ppbc.vue?vue&type=template&id=d7f50f44&scoped=true&"
import script from "./ppbc.vue?vue&type=script&lang=js&"
export * from "./ppbc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f50f44",
  null
  
)

export default component.exports